export default __webpack_public_path__ + "static/media/indraDiscipulos.d98f345e.jpg";